export default {
    topics: [
        {
            title: ' Cancel ',
            href: 'sm-task-Cancel.html',
            attributes: { 'data-id': 'sm-task-Cancel' },
            menu: { hasChildren: false },
            tocID: 'sm-task-Cancel-d66e3992',
            topics: [],
        },
        {
            title: ' CheckAccess ',
            href: 'sm-task-CheckAccess.html',
            attributes: { 'data-id': 'sm-task-CheckAccess' },
            menu: { hasChildren: false },
            tocID: 'sm-task-CheckAccess-d66e4000',
            topics: [],
        },
        {
            title: ' CheckPlanningTask ',
            href: 'sm-task-CheckPlanningTask.html',
            attributes: { 'data-id': 'sm-task-CheckPlanningTask' },
            menu: { hasChildren: false },
            tocID: 'sm-task-CheckPlanningTask-d66e4008',
            topics: [],
        },
        {
            title: ' CheckValidationAccess ',
            href: 'sm-task-CheckValidationAccess.html',
            attributes: { 'data-id': 'sm-task-CheckValidationAccess' },
            menu: { hasChildren: false },
            tocID: 'sm-task-CheckValidationAccess-d66e4016',
            topics: [],
        },
        {
            title: ' Finish ',
            href: 'sm-task-Finish.html',
            attributes: { 'data-id': 'sm-task-Finish' },
            menu: { hasChildren: false },
            tocID: 'sm-task-Finish-d66e4024',
            topics: [],
        },
        {
            title: ' Reset ',
            href: 'sm-task-Reset.html',
            attributes: { 'data-id': 'sm-task-Reset' },
            menu: { hasChildren: false },
            tocID: 'sm-task-Reset-d66e4032',
            topics: [],
        },
        {
            title: ' Validation ',
            href: 'sm-task-Validation.html',
            attributes: { 'data-id': 'sm-task-Validation' },
            menu: { hasChildren: false },
            tocID: 'sm-task-Validation-d66e4040',
            topics: [],
        },
    ],
};

